export const projectsMock = [
    {
        id: 1,
        title: "Réhabilitation de la Route Nationale 1",
        axis: "Infrastructures",
        province: "Estuaire",
        status: "EN_COURS",
        progress: 65,
        budget: 12500000000,
        startDate: "2023-03-01",
        endDate: "2025-12-31",
        partners: ["Banque Mondiale", "État Gabonais"],
        description:
            "Projet de réhabilitation et de modernisation de la RN1 visant à améliorer la mobilité, la sécurité routière et la compétitivité économique.",
        objectives: [
            "Améliorer la fluidité du trafic",
            "Réduire les accidents",
            "Faciliter l’accès aux zones économiques"
        ],
        image: "/assets/images/projects/route.jpg",
        timeline: [
            {
                date: "2023-03-01",
                title: "Lancement du projet",
                description: "Signature des accords et démarrage officiel du projet.",
                status: "DONE"
            },
            {
                date: "2023-09-15",
                title: "Études techniques",
                description: "Études de faisabilité et diagnostics techniques.",
                status: "DONE"
            },
            {
                date: "2024-06-01",
                title: "Travaux de réhabilitation",
                description: "Travaux routiers en cours sur plusieurs tronçons.",
                status: "CURRENT"
            },
            {
                date: "2025-12-31",
                title: "Réception finale",
                description: "Livraison définitive et mise en exploitation.",
                status: "PENDING"
            }
        ]
    },

    {
        id: 2,
        title: "Construction du centre hospitalier régional",
        axis: "Santé",
        province: "Haut-Ogooué",
        status: "TERMINE",
        progress: 100,
        description:
            "Construction d’un hôpital moderne pour renforcer l’offre de soins de proximité.",
        image: "/assets/images/projects/hopital.jpg",
        timeline: [
            {
                date: "2021-01-10",
                title: "Études et conception",
                description: "Études architecturales et techniques.",
                status: "DONE"
            },
            {
                date: "2021-08-01",
                title: "Travaux de construction",
                description: "Construction des infrastructures hospitalières.",
                status: "DONE"
            },
            {
                date: "2023-11-30",
                title: "Équipement et réception",
                description: "Installation des équipements et ouverture officielle.",
                status: "DONE"
            }
        ]
    },

    {
        id: 3,
        title: "Programme de formation des jeunes aux métiers du numérique",
        axis: "Capital humain",
        province: "Woleu-Ntem",
        status: "EN_PREPARATION",
        progress: 20,
        description:
            "Renforcement des compétences numériques des jeunes pour favoriser l’employabilité.",
        image: "/assets/images/projects/formation.jpg",
        timeline: [
            {
                date: "2024-10-01",
                title: "Conception du programme",
                description: "Définition des modules et partenariats.",
                status: "DONE"
            },
            {
                date: "2025-02-01",
                title: "Sélection des bénéficiaires",
                description: "Appel à candidatures et sélection des jeunes.",
                status: "CURRENT"
            },
            {
                date: "2025-06-01",
                title: "Démarrage des formations",
                description: "Lancement officiel des sessions de formation.",
                status: "PENDING"
            }
        ]
    }
];
